import { useEffect } from "react";
import Center from "../components/utils/Center";

interface Props {}

const HowItWorksPage = ({}: Props) => {

  return (
    <>
      <title>How It Works | Tuttobanana</title>
      <meta name="description" content="See how Tuttobanana works in a few simple steps. Pick a banana, send it with love, and spread smiles across the Bananaverse." />

      <div className="bg-gray-100 text-gray-900 px-6 py-20 sm:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-yellow-500">
            How It Works
          </h1>
          <p className="text-lg text-gray-700 mb-12">
            Sending joy is easier than peeling a banana. Here's how Tuttobanana spreads smiles across the globe.
          </p>
        </div>

        <div className="space-y-12 max-w-3xl mx-auto">
          <Step
            number={1}
            title="🍌 Pick a Banana"
            desc="Head to the Banana Stand and choose from a variety of animated bananas, thank you, love, wink, congrats, we've got your vibe."
          />
          <Step
            number={2}
            title="📨 Send It"
            desc="Share your banana via email, text, or social, we generate a unique link and tracking ID."
          />
          <Step
            number={3}
            title="😁 Unwrap & Smile"
            desc="The recipient unwraps a banana with a fun animation and your heartfelt message. Instant joy!"
          />
          <Step
            number={4}
            title="💛 Banana It Forward or Back"
            desc="They can forward the same banana to someone else or send it back to you. Emotional chain reaction is now unlocked!"
          />
          <Step
            number={5}
            title="☺️ Spread the Joy"
            desc="Banana it forward to someone new!"
          />
        </div>
      </div>
    </>
  );
};

const Step = ({ number, title, desc }: { number: number; title: string; desc: string }) => (
  <div className="flex items-start gap-4">
    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-yellow-400 text-gray-900 font-bold flex items-center justify-center">
      {number}
    </div>
    <div>
      <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
      <p className="text-gray-700 mt-1">{desc}</p>
    </div>
  </div>
);

export default HowItWorksPage;
